import { ImageVariant } from '../common/components/Image/contracts';

export const getCachedImage = (src: string, variant: ImageVariant) => {
  // @ts-ignore
  const cloudflareUrl = import.meta.env.VITE_CLOUDFLARE_URL;

  if (cloudflareUrl && variant && typeof src === 'string' && src.startsWith('http')) {
    const cloudflareSrc = `${cloudflareUrl}?image=${src}`;
    src = `${cloudflareSrc}&variant=${variant}&fit=contain`;
  }

  return src;
};
